export function coerceToBoolean(value: any): boolean {
  if (value === true || value === false) return value;
  if (value === null || value === undefined || value === '') return false;

  if (typeof value === 'string') {
    const normalized = value.trim().toLowerCase();
    if (normalized === 'true' || normalized === '1' || normalized === 'yes' || normalized === 'y') {
      return true;
    }
    if (normalized === 'false' || normalized === '0' || normalized === 'no' || normalized === 'n') {
      return false;
    }
  }

  if (typeof value === 'number') {
    if (value === 0) return false;
    if (value === 1) return true;
    return value !== 0;
  }

  return !!value;
}

export function normalizeBooleanComparison(left: any, right: any): { left: any; right: any } {
  if (typeof right === 'boolean') {
    return { left: coerceToBoolean(left), right };
  }

  if (typeof left === 'boolean') {
    return { left, right: coerceToBoolean(right) };
  }

  return { left, right };
}

export function getValueByPath(values: Record<string, any>, path: string): any {
  if (!path.includes('.')) return values?.[path];

  return path.split('.').reduce((current, segment) => current?.[segment], values);
}

export function isEmptyValue(value: any, rawValue?: any): boolean {
  if (typeof rawValue === 'string' && rawValue.trim() === '') return true;
  if (value === null || value === undefined || value === '') return true;
  if (typeof value === 'number' && Number.isNaN(value)) return true;
  return Array.isArray(value) && value.length === 0;
}
